@let readOnly = $readOnly();

<form [formGroup]="formGroup">
  <div class="x-card x-card_size_m x-white card-shadow">
    <p class="x-island-header">
      {{ 'request_form.common.supplier.title' | translate }}
    </p>

    <div class="x-input-label">
      {{ 'request_form.common.supplier.delivery_name' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.DeliveryName"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.supplier.delivery_address' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          tuiInput
          [formControlName]="FormFields.DeliveryAddress"
          [readOnly]="readOnly"
        />
        <tui-icon tuiCopy />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.supplier.delivery_person_name' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.DeliveryPersonName"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{
        'request_form.common.supplier.delivery_person_phone_number' | translate
      }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.DeliveryPersonPhone"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{
        'request_form.common.supplier.delivery_person_phone_email' | translate
      }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.DeliveryPersonEmail"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <p class="x-island-header mt-5">
      {{ 'request_form.common.supplier.release_title' | translate }}
    </p>

    <div class="x-input-label">
      {{ 'request_form.common.supplier.actual_release_date' | translate }}
    </div>
    @if (requestService.$request().actualReleaseDate) {
      <div class="x-text-red text-xs mb-1">
        {{
          'request_form.common.supplier.actual_release_date_differs' | translate
        }}
      </div>
    }
    <div>
      <tui-textfield xHyphenedStringTuiDateTransformer tuiTextfieldSize="m">
        <input
          tuiInputDate
          type="date"
          [formControlName]="FormFields.ReleaseDate"
          [readOnly]="readOnly"
          placeholder="{{
            'request_form.common.supplier.release_date_placeholder' | translate
          }}"
        />
        <tui-calendar *tuiDropdown />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.supplier.release_time' | translate }}
    </div>
    <div>
      <x-time-picker
        [formControlName]="FormFields.ReleaseTime"
        [minutesGap]="15"
        [readOnly]="readOnly"
      ></x-time-picker>
    </div>

    <x-request-form-common-supplier-actual-release-date />
  </div>
</form>
